<template>
  <VCard v-if="tags.length" class="tw-w-full" padding="5">
    <section>
      <div class="tw-mb-6 tw-flex">
        <img :src="getMediaUrl('gradientHeart.svg')" alt="" class="tw-mr-2" />
        <VText class="tw-block" cfg="sans/20/bold" html-tag="h2">
          {{ $t('influencer.profile.slug.genresAcceptedOften') }}
        </VText>
      </div>
      <TagGridTemplate class="tw-mb-0" padding-class="tw-px-0">
        <TagElement
          v-for="(tag, index) in tags"
          :key="index"
          i18nkey="subgenre"
          :readonly="true"
          :tag="tag"
        />
      </TagGridTemplate>
    </section>
  </VCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TagElement from '~/components/tag/element.vue'
import TagGridTemplate from '~/components/tag/gridTemplate.vue'
import VCard from '~/components/ui/VCard.vue'
import VText from '~/components/ui/VText.vue'

import { useGetMediaUrl } from '~/composables/useGetMediaUrl'

import { useTagStore } from '~/stores/tag'

import type Tag from '~/entities/tag'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    TagElement,
    TagGridTemplate,
    VCard,
    VText,
  },
  props: {
    genreIds: {
      type: Array as PropType<Tag['id'][]>,
      required: true,
    },
  },
  setup() {
    const { getMediaUrl } = useGetMediaUrl()
    const { GET_TAGS_FROM_IDS } = useTagStore()

    return { getMediaUrl, GET_TAGS_FROM_IDS }
  },
  computed: {
    tags(): Tag[] {
      return this.GET_TAGS_FROM_IDS(this.genreIds).sort(
        (tagA: Tag, tagB: Tag) =>
          this.genreIds.indexOf(tagA.id) - this.genreIds.indexOf(tagB.id),
      )
    },
  },
})
</script>
